import controller from './camera.controller';
import template from './camera.html';
import './camera.scss';

export default {
	template,
	bindings: {
		cancel: '&?onCancel',
		model:  '<ngModel',
		submit: '&?onSubmit',
	},
	controller,
	require:  {
		ngModelCtrl: '?ngModel',
	},
};
